import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { Events } from '@providers/common/events.service';

import { HtmlExcelExportService } from '@providers/excel/html-excel.service';
import { addIcons } from "ionicons";
import { close } from "ionicons/icons";

@Component({
    selector: 'modal-table-detail',
    templateUrl: './modal-table-detail.component.html',
    styleUrls: ['./modal-table-detail.component.scss'],
    standalone: false,
})
export class TableDetailChatAIModal implements OnInit {
    @Input('modalTitle') modalTitle: string = '';
    @Input('modalType') modalType: string = '';
    @Input('tableFinanceDetail') tableFinanceDetail: string = '';
    @Input('tableOperationsDetail') tableOperationsDetail: string = '';

    constructor(
        private modalCtrl: ModalController,
        private events: Events,
        private excelExport: HtmlExcelExportService,
    ) {
        this.events.publish('menulat:togglevisibility');
        addIcons({ close });
    }

    ngOnInit() { }

    /**
     * @name dismiss
     * @desc Metodo que te regresa en la navegación
     **/
    dismiss() {
        this.events.publish('menulat:togglevisibility');
        this.modalCtrl.dismiss();
    }

    /* Parse and Generate excel file from Data */
    onParseDataToExcelFile(dataType: string) {

        let fileName: string;

        if (dataType === 'Financial') {

            fileName = 'FinancialData';

            this.excelExport.exportHtmlStringToExcel(this.tableFinanceDetail, fileName);

        } else {

            fileName = 'OperationsData';
            this.excelExport.exportHtmlStringToExcel(this.tableOperationsDetail, fileName);
        }
    }
}
